<template>
  <Overlay v-if="isVisible" background="rgba(255, 255, 255, .6)">
    <div class="multi-loader">
      <TimeoutSlots :need-to-stop="needToStop" :timeouts="[1000, 3000]">
        <div></div>
        <SpinnerLoader />
        <ProgressBar :need-to-stop="needToStop" @stop="onProgressStop" />
      </TimeoutSlots>
    </div>
  </Overlay>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import { TimeoutSlots } from '~packages/timeout-slots';

import { useLoading } from '@/shared/lib';

import { ProgressBar } from '../../../ProgressBar';
import { Overlay, SpinnerLoader } from './ui';

const { isLoading } = useLoading();

const isVisible = ref(false);
const needToStop = ref(false);

watch(isLoading, val => {
  if (val) {
    isVisible.value = val;
    needToStop.value = false;
    return;
  }

  needToStop.value = true;

  /*  */
  const reset = () => {
    if (isVisible.value) {
      isVisible.value = false;
    }
  };

  reset();
});

const onProgressStop = () => {
  isVisible.value = false;
};
</script>

<style src="./MultiLoader.scss" lang="scss" scoped />
